import { html as htmlPreact } from 'htm/preact';
import type { VNode } from 'preact';

/**
 * Preact + htm, no JSX.
 *
 * The repo's tsconfig sets no `jsx` option and this package does not own that
 * file, so tagged templates are the correct call rather than a workaround — and
 * htm is ~600 bytes on top of Preact, which matters because the same rendering
 * code is shared with the MCP Apps widget where bundle size is a hard constraint.
 */
export const html = htmlPreact as (
  strings: TemplateStringsArray,
  ...values: unknown[]
) => VNode;

/**
 * An explicit space.
 *
 * htm trims the whitespace at the edges of any static text chunk that contains
 * a newline, so `…your tools\n  on <code>x</code>` renders as "ondocument" —
 * a real bug that shipped in the first pass of this console and is invisible in
 * the source. Interpolating `SP` where a wrapped line needs a space is the
 * documented workaround, and naming it makes the intent obvious at the call
 * site rather than looking like a stray `${' '}`.
 */
export const SP = ' ';

export type { VNode };
